import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import OrdersModal from './OrdersModal';

interface OrdersModalButtonProps {
  orderIds: string[];
  currency: string;
  period?: {
    start: string;
    end: string;
  };
  settlementType?: 'INFLUENCER_BONUS' | 'LOYALTY_ROYALTY';
  disabled?: boolean;
  variant?: string;
  size?: 'sm' | 'lg';
  className?: string;
  children?: React.ReactNode;
}

const OrdersModalButton: React.FC<OrdersModalButtonProps> = ({
  orderIds,
  currency,
  period,
  settlementType,
  disabled = false,
  variant = 'outline-primary',
  size = 'sm',
  className = '',
  children = 'Ver Órdenes'
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  console.log(orderIds);

  return (
    <>
      <Button
        variant={variant}
        size={size}
        onClick={toggleModal}
        disabled={disabled || orderIds.length === 0}
        className={className}
      >
        {children} ({orderIds.length})
      </Button>

      <OrdersModal
        show={isModalOpen}
        onHide={toggleModal}
        orderIds={orderIds}
        currency={currency}
        period={period}
        settlementType={settlementType}
      />
    </>
  );
};

export default OrdersModalButton;
